import { useContext, useMemo } from "react";
import { ConstantContext } from "components/context/ConstantProvider";

const useNeedASponsor = ({
  investment_status,
  dealFlowId,
  deal_owner,
  secondary_owner,
}) => {
  const { dealFlows } = useContext(ConstantContext);

  const need_a_sponsor = useMemo(() => {
    const dealFlowsDictionary = Object.fromEntries(
      dealFlows.map((x) => [x.id, x]),
    );
    if (!investment_status || !dealFlowId) return false;
    if ([3, 4, 5, 6, 7, 11].indexOf(Number(investment_status)) == -1)
      return false;
    const requested_owners_ids =
      dealFlowsDictionary[dealFlowId].requested_owners_ids;
    if (requested_owners_ids.length == 0) return false;
    if (
      requested_owners_ids.indexOf(Number(deal_owner)) > -1 ||
      requested_owners_ids.indexOf(Number(secondary_owner)) > -1
    )
      return false;
    return true;
  }, [investment_status, dealFlowId, deal_owner, secondary_owner]);

  return need_a_sponsor;
};

export default useNeedASponsor;
